import { render, staticRenderFns } from "./BaseStatsCard.vue?vue&type=template&id=0e460b2c&"
import script from "./BaseStatsCard.vue?vue&type=script&lang=js&"
export * from "./BaseStatsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e460b2c')) {
      api.createRecord('0e460b2c', component.options)
    } else {
      api.reload('0e460b2c', component.options)
    }
    module.hot.accept("./BaseStatsCard.vue?vue&type=template&id=0e460b2c&", function () {
      api.rerender('0e460b2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Bases/Cards/BaseStatsCard.vue"
export default component.exports